/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Wallet_Not_ConnectedInputs */

const en_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your wallet to deposit.`)
};

const de_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden Sie Ihre Wallet, um einzuzahlen.`)
};

const pt_br2_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte sua carteira para depositar.`)
};

const tr_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para yatırmak için cüzdanınızı bağlayın.`)
};

const zh_cn2_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请连接您的钱包以进行存入。`)
};

const zh_hk2_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請連接你的錢包以進行存入。`)
};

const ko_kr2_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입금하려면 지갑을 연결하세요.`)
};

const ru_ru2_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключите кошелёк для пополнения.`)
};

const es_419_deposit_error_wallet_not_connected = /** @type {(inputs: Deposit_Error_Wallet_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta tu billetera para depositar.`)
};

/**
* | output |
* | --- |
* | "Connect your wallet to deposit." |
*
* @param {Deposit_Error_Wallet_Not_ConnectedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_wallet_not_connected = /** @type {((inputs?: Deposit_Error_Wallet_Not_ConnectedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Wallet_Not_ConnectedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_wallet_not_connected(inputs)
	if (locale === "de") return de_deposit_error_wallet_not_connected(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_wallet_not_connected(inputs)
	if (locale === "tr") return tr_deposit_error_wallet_not_connected(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_wallet_not_connected(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_wallet_not_connected(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_wallet_not_connected(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_wallet_not_connected(inputs)
	return es_419_deposit_error_wallet_not_connected(inputs)
});